<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            :brands="brands"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Products/ProductAddonGroups/Form'

export default {
    name: 'ProductAddonGroupCreate',
    components: {
        Form
    },
    props: {
        errors: {
            type: Object,
            default () {
                return {}
            }
        },
        brands: {
            type: Array,
            default () {
                return []
            }
        }
    },
    methods: {
        submitData (form) {
            form.post(this.$route('products.product-addon-groups.store'))
        }
    }
}
</script>
